export default __webpack_public_path__ + "bff65274836bc3e134025bda8516b909.png";